import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import InputBase from '@material-ui/core/InputBase'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import SearchIcon from '@material-ui/icons/Search'
import BackspaceIcon from '@material-ui/icons/Backspace'
import { trackEvent } from '../../helpers/analytics'
import { trackWidgetClick } from '../../helpers/trackWidgetClick'
import {
  updateSearchQuery,
  updateSearchBarContents,
  showSearchBarContents,
} from '../../features/apps/appSlice'
// import {
//   setSearchValue,
//   setSelectedRoutes,
//   setSelectedStops,
// } from '../../../maps/sections/Map/redux/myMapsSlice'
// import { setSelectedCampusBuildings } from '../../../maps/sections/Buildings/redux/myBuildingsSlice'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    minHeight: 40,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}))

// searchOnSubmit defaults to false: the parent filters as the user types via onChange.
// When true, typing only updates the input, clicking Search or pressing Enter
// calls onRequestSearch. The search icon is shown only when searchOnSubmit is true.
export default function CustomizedInputBase({
  placeholder,
  value,
  onChange,
  onRequestSearch,
  onCancelSearch,
  searchOnSubmit = false,
  moduleName,
  widgetId,
  dispatch,
}) {
  const classes = useStyles()
  // const route = window.location.pathname
  const searchTimer = React.useRef(null)

  React.useEffect(() => () => clearTimeout(searchTimer.current), [])

  // const trackSearchSubmit = (trigger) => {
  //   trackEvent(dispatch, {
  //     eventName: 'uxp_search_submit',
  //     module: 'UXP Shell',
  //     object: 'SearchBar',
  //     objectId: moduleName || 'SearchBar',
  //     action: 'Search',
  //     actionContext: trigger,
  //     actionContextValue: value ? 'SearchValueEntered' : 'EmptySearch',
  //     page: 'Shell',
  //     route,
  //     url: route,
  //     rcpid: localStorage.getItem('rutgersEduRCPID'),
  //     backendEvent: {
  //       module: 'SearchBar',
  //       object: 'SearchInput',
  //       objectId: moduleName || 'SearchBar',
  //       action: 'Search',
  //       actionContext: trigger,
  //       actionContextValue: value ? 'SearchValueEntered' : 'EmptySearch',
  //       rcpid: localStorage.getItem('rutgersEduRCPID'),
  //       url: route,
  //       timestamp: Date.now(),
  //     },
  //   })
  // }

  // const trackSearchClear = () => {
  //   trackEvent(dispatch, {
  //     eventName: 'uxp_search_clear',
  //     module: 'UXP Shell',
  //     object: 'SearchBar',
  //     objectId: moduleName || 'SearchBar',
  //     action: 'Clear',
  //     actionContext: 'ClearSearch',
  //     actionContextValue: value ? 'HadSearchValue' : 'EmptySearch',
  //     page: 'Shell',
  //     route,
  //     url: route,
  //     rcpid: localStorage.getItem('rutgersEduRCPID'),
  //     backendEvent: {
  //       module: 'SearchBar',
  //       object: 'SearchInput',
  //       objectId: moduleName || 'SearchBar',
  //       action: 'Clear',
  //       actionContext: 'ClearSearch',
  //       actionContextValue: value ? 'HadSearchValue' : 'EmptySearch',
  //       rcpid: localStorage.getItem('rutgersEduRCPID'),
  //       url: route,
  //       timestamp: Date.now(),
  //     },
  //   })
  // }

  // const handleRequestSearch = () => {
  //   trackSearchSubmit('SearchButton')
  //   onRequestSearch()
  // }

  // const handleClearSearch = () => {
  //   trackSearchClear()
  //   onCancelSearch()
  // }

  const handleRequestSearch = () => {
    if (!searchOnSubmit || !onRequestSearch) return
    trackWidgetClick(
      dispatch,
      widgetId || 'SearchBar',
      moduleName || placeholder || 'Search',
      { widgetId },
    )
    onRequestSearch()
  }

  const handleClearSearch = () => {
    clearTimeout(searchTimer.current)
    trackWidgetClick(
      dispatch,
      widgetId || 'SearchBar',
      `Clear ${moduleName || placeholder || 'Search'}`,
      { widgetId },
    )
    onCancelSearch()
  }

  const handleSearchChange = (e) => {
    onChange(e)

    const searchValue = e.target.value

    if (searchTimer.current) {
      clearTimeout(searchTimer.current)
    }
    if (!searchOnSubmit && searchValue && searchValue.trim().length > 0) {
      searchTimer.current = setTimeout(() => {
        trackEvent(dispatch, {
          eventName: 'uxp_dashboard_widget_search',
          module: 'Dashboard',
          object: 'Widget',
          action: 'Search',
          actionContext: 'WidgetSearch',
          actionContextValue: moduleName || placeholder || 'WidgetNameNotFound',
        })
      }, 1000)
    }
  }
  return (
    <Paper
      component="form"
      className={classes.root}
      variant="outlined"
      onSubmit={(event) => {
        event.preventDefault()
        handleRequestSearch()
      }}
    >
      <InputBase
        className={classes.input}
        placeholder={placeholder}
        value={value}
        onChange={handleSearchChange}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            if (moduleName === 'myApps') {
              dispatch(updateSearchQuery(''))
              dispatch(updateSearchBarContents([]))
              dispatch(showSearchBarContents(false))
            }
            if (moduleName === 'myMaps') {
              onCancelSearch()
            }
          }
        }}
        inputProps={{ 'aria-label': 'search' }}
        endAdornment={
          value ? (
            <IconButton
              type="button"
              onClick={handleClearSearch}
              className={classes.iconButton}
              aria-label="Clear search"
            >
              <BackspaceIcon />
            </IconButton>
          ) : null
        }
      />
      {searchOnSubmit && (
        <>
          <Divider className={classes.divider} orientation="vertical" />
          <IconButton
            type="submit"
            className={classes.iconButton}
            aria-label="search"
          >
            <SearchIcon />
          </IconButton>
        </>
      )}
    </Paper>
  )
}
